import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

const CertifierSummaryCardsTemplate = observer(function CertifierSummaryCardsTemplate({ summary, t }) {
    return (
        <div className="row u-mar--bottom--med">
            <div className="col col-sml-6 col-lrg-3">
                <div className="c-card--primary u-padd--med">
                    <p className="u-type--sml u-type--color--opaque">
                        {t("APPLICATION.CERTIFIER.DASHBOARD.SUMMARY.TOTAL")}
                    </p>
                    <p className="u-type--lrg u-type--wgt--bold">{summary ? summary.totalCount : "--"}</p>
                </div>
            </div>
            <div className="col col-sml-6 col-lrg-3">
                <div className="c-card--primary u-padd--med">
                    <p className="u-type--sml u-type--color--opaque">
                        {t("APPLICATION.CERTIFIER.DASHBOARD.SUMMARY.APPROVED")}
                    </p>
                    <p className="u-type--lrg u-type--wgt--bold u-type--color--success">
                        {summary ? summary.approvedCount : "--"}
                    </p>
                </div>
            </div>
            <div className="col col-sml-6 col-lrg-3">
                <div className="c-card--primary u-padd--med">
                    <p className="u-type--sml u-type--color--opaque">
                        {t("APPLICATION.CERTIFIER.DASHBOARD.SUMMARY.REJECTED")}
                    </p>
                    <p className="u-type--lrg u-type--wgt--bold u-type--color--error">
                        {summary ? summary.rejectedCount : "--"}
                    </p>
                </div>
            </div>
            <div className="col col-sml-6 col-lrg-3">
                <div className="c-card--primary u-padd--med">
                    <p className="u-type--sml u-type--color--opaque">
                        {t("APPLICATION.CERTIFIER.DASHBOARD.SUMMARY.PENDING")}
                    </p>
                    <p className="u-type--lrg u-type--wgt--bold u-type--color--warning">
                        {summary ? summary.pendingCount : "--"}
                    </p>
                </div>
            </div>
        </div>
    );
});

CertifierSummaryCardsTemplate.propTypes = {
    summary: PropTypes.object,
    t: PropTypes.func.isRequired,
};

export default CertifierSummaryCardsTemplate;
